export { default, type IProps } from "./TextInput";
